import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Alertsuccess,
  Alertwarning,
  DecodeString,
  EncodeString,
  GetCookieV2,
  getData,
  setData,
} from "../../Utils";
import { mainAction } from "../../Redux/Actions";
import { useInput } from "../../Hooks";
import { LANE } from "../../Enum";
import I18n from "../../Language";
import { Img } from "react-image";
import { Button, Form, Input, Modal, Progress, Typography } from "antd";
import { LockOutlined, SaveOutlined } from "@ant-design/icons";

export const HeaderMenu = () => {
  const dispatch = useDispatch();
  const dtLogin = GetCookieV2("All");
  const [LangName, setLangName] = useState(I18n.t("Header.Vietnamese"));
  const [LangIcon, setLangIcon] = useState("/assets/img/vn.png");
  const [isLock, setIsLock] = useState(dtLogin?.IsLock);

  const [Codesearch, bindCodesearch, setCodesearch] = useInput("");
  const CustomerGroup = dtLogin?.Group;
  const [Customers, setCustomers] = useState(dtLogin?.Customers);
  const [Customer, setCustomer] = useState(dtLogin?.Active);
  const [CurrentName, setCurrentName] = useState("");

  useEffect(() => {
    //#region Đa ngôn ngữ hệ thống
    initialLanguage();
    //#endregion

    if (dtLogin?.IsLoginByGroup === 1)
      setCurrentName("Nhóm KH: " + CustomerGroup?.CustomerGroupName);
    else setCurrentName(Customer?.StaffName || Customer?.CustomerCode);
  }, []);

  const setNewCookie = async (item) => {
    let ensc = EncodeString(JSON.stringify(item));
    localStorage.setItem("login", ensc);
    updateCookie("True");
    window.location.reload();
  };

  const updateCookie = (key) => {
    let group = JSON.parse(DecodeString(localStorage.getItem("GroupInfo")));
    group.IsChooseCustomer = key;
    let enscG = EncodeString(JSON.stringify(group));
    localStorage.setItem("GroupInfo", enscG);
    window.location.reload();
  };

  const onClickLogout = () => {
    localStorage.setItem("clgv3", "");
    window.location.href = "/";
  };

  const Link = (Codesearch) => {
    window.location.href = "/tra-cuu-van-don?code=" + Codesearch.trim();
  };
  const onKeyUp = (e) => {
    if (e.charCode == 13) {
      Link(Codesearch);
    }
  };

  //#region đa ngôn ngữ hệ thống
  const changeLanguage = async (keylang) => {
    let lang = await getData(LANE);

    let params = {
      language: keylang,
      Type: 1,
    };
    const language = await mainAction.changeLanguage(params, dispatch);
    await setData(LANE, JSON.stringify(language));
    //#region đa ngôn ngữ leftmenu
    localStorage.setItem("keyLang", keylang);
    window.location.reload();
    //#endregion
  };

  const initialLanguage = () => {
    dispatch(mainAction.checkLanguage(null));
    const keyLang = localStorage.getItem("keyLang");
    if (keyLang !== "EN" && keyLang !== "en") {
      setLangName("Tiếng Việt");
      setLangIcon("/assets/img/vn.png");
      localStorage.setItem("keyLang", "VN");
    } else {
      setLangName("English");
      setLangIcon("/assets/img/en.png");
    }
  };
  //#endregion

  const MenuNoGroup = (
    <ul className="navbar-nav">
      <li className="nav-item dropdown hide-sm">
        <a
          className="nav-link height50"
          href="#"
          id="navbarDropdownGroup"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div>
            <span className="CustomerName">{CurrentName}</span>
          </div>
          <div style={{ float: "right", marginBottom: "7px" }}>
            <span style={{ textTransform: "capitalize", color: "#9696A0" }}>
              Manager Account
            </span>
            <i
              className="material-icons"
              style={{ fontSize: "17px", top: "1px", color: "#9696A0" }}
            >
              expand_more
            </i>
          </div>
        </a>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownGroup"
        >
          <a className="dropdown-item" href="#" onClick={onClickLogout}>
            Đăng xuất
          </a>
        </div>
      </li>
      <li className="nav-item dropdown hide-sm left-25s">
        {/* <img src={Customer?.LinkAvatar} className='CustomerAvartar' width="100" /> */}
        <img
          src={"/assets/img/new_logo.png"}
          className="CustomerAvartar"
          width="100"
        />
      </li>
      {/* <li className="nav-item dropdown hide-sm">
        <a
          className="nav-link"
          href="#"
          id="navbarDropdownGroup"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >

          <div>
            <img src="../assets/img/vn.png" style={{ borderRadius: '3px' }} width="25px" />
            <i className="material-icons" style={{ fontSize: '22px', top: '2px', color: '#9696A0' }}>arrow_drop_down</i>
          </div>
        </a>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownGroup"
        >
          <a className="dropdown-item bor-bottom" href="#">
            <img src="../assets/img/vn.png" style={{ borderRadius: '3px', marginRight: '8px' }} width="30" />  VIETNAM
          </a>
          <a className="dropdown-item" href="#" >
            <img src="../assets/img/en.png" style={{ borderRadius: '3px', marginRight: '8px' }} width="30" /> ENGLISH
          </a>
        </div>
      </li> */}
    </ul>
  );

  const MenuHaveGroup = (
    <ul className="navbar-nav mt0">
      <li className="nav-item dropdown">
        <a
          className="nav-link"
          href="javascript:;"
          id="navbarDropdownGroup"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            className="material-icons"
            style={{ marginRight: "10px", color: "#00884E" }}
          >
            group
          </i>
          <span>{CurrentName}</span>
          <i
            className="material-icons"
            style={{ fontSize: "22px", top: "2px", color: "#9696A0" }}
          >
            arrow_drop_down
          </i>
        </a>
        <div
          className="dropdown-menu dropdown-menu-right header-scroll"
          aria-labelledby="navbarDropdownGroup"
        >
          <a
            className="dropdown-item"
            key={0}
            href="#"
            onClick={() => {
              setCurrentName("Nhóm KH: " + CustomerGroup?.CustomerGroupName);
              updateCookie("Fail");
            }}
          >
            {"Nhóm KH: " + CustomerGroup?.CustomerGroupName}
          </a>
          {Customers?.map((item, index) => {
            return (
              <a
                className={
                  item.CustomerID === Customer?.CustomerID
                    ? "active dropdown-item"
                    : "dropdown-item"
                }
                key={index}
                href="#"
                onClick={() => setNewCookie(item)}
              >
                {item.CustomerCode + " - " + item.CustomerName}
              </a>
            );
          })}
        </div>
      </li>
      {/* <li className="nav-item dropdown hide-sm">
        <a
          className="nav-link"
          href="#"
          id="navbarDropdownGroup"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >

          <div>
            <img src="../assets/img/vn.png" style={{ borderRadius: '3px' }} width="25px" />
            <i className="material-icons" style={{ fontSize: '22px', top: '2px', color: '#9696A0' }}>arrow_drop_down</i>
          </div>
        </a>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownGroup"
        >
          <a className="dropdown-item bor-bottom" href="#">
            <img src="../assets/img/vn.png" style={{ borderRadius: '3px', marginRight: '8px' }} width="30" />  VIETNAM
          </a>
          <a className="dropdown-item" href="#" >
            <img src="../assets/img/en.png" style={{ borderRadius: '3px', marginRight: '8px' }} width="30" /> ENGLISH
          </a>
        </div>
      </li> */}
    </ul>
  );

  //#region Kiểm tra nếu là pass mặc định thì bắt buộc đổi pass
  const [form] = Form.useForm();

  const strengthLabels = [
    "Rất yếu", // 0
    "Yếu", // 1
    "Trung bình", // 2
    "Khá", // 3
    "Mạnh", // 4
    "Rất mạnh", // 5
  ];

  const strengthColors = [
    "#ff4d4f", // đỏ
    "#ff7a45", // cam
    "#faad14", // vàng
    "#a0d911", // xanh lá nhẹ
    "#52c41a", // xanh chuẩn
    "#389e0d", // xanh đậm
  ];

  const [passwordStrength, setPasswordStrength] = useState(0);

  const onFinish = (values) => {
    // ✅ Reset toàn bộ form sau khi submit
    form.resetFields();
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    const score = getPasswordStrength(value);
    setPasswordStrength(score);
  };

  const getPasswordStrength = (password) => {
    if (!password) return 0;

    const hasUpper = /[A-Z]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    const hasSpecial = /[^A-Za-z0-9]/.test(password);
    const length = password.length;
    const typesCount = [hasUpper, hasDigit, hasSpecial].filter(Boolean).length;

    if (length < 6 || typesCount < 2) return 1;
    if (length >= 6 && typesCount === 2) return 2;
    if (length >= 6 && typesCount >= 2) return 3;
    if (length >= 6 && typesCount === 3) return 4;
    if (length >= 10 && typesCount === 3) return 5;

    return 1;
  };

  const APIC_spCustomerResetPass_V2 = async () => {
    try {
      // ✅ Kiểm tra mật khẩu mới
      if (passwordStrength < 3) {
        form.setFields([
          {
            name: "formError",
            errors: [
              "Mật khẩu phải từ 8 ký tự trở lên và bao gồm chữ in hoa, số và ký tự đặc biệt(vd: A,B,C@!#...).",
            ],
          },
        ]);
        return;
      }

      if (form.getFieldValue("newPassword").toLowerCase().includes("netco")) {
        form.setFields([
          {
            name: "formError",
            errors: ["Mật khẩu không được chứa từ 'netco'."],
          },
        ]);
        return;
      }

      if (
        form.getFieldValue("newPassword") !==
        form.getFieldValue("confirmPassword")
      ) {
        form.setFields([
          { name: "formError", errors: ["Mật khẩu xác nhận không khớp."] },
        ]);
        return;
      }

      // ✅ Kiểm tra và lấy giá trị từ form
      const values = await form.validateFields(); // kiểm tra toàn bộ form đổi mk

      const paramsde = {
        Json: values.newPassword,
        func: "EncryptString",
      };
      const passnewde = await mainAction.EncryptString(paramsde, dispatch);
      let prp = {
        CustomerID: Customers[0].CustomerID,
        Password: passnewde,
        PasswordOld: values.newPassword,
      };

      const paramp = {
        Json: JSON.stringify(prp),
        func: "APIC_spCustomerResetPass_V2",
      };
      const resultsms = await mainAction.API_spCallServer(paramp, dispatch);
      Alertsuccess(resultsms.Message);
      let newLogin = { ...dtLogin, IsLock: false };
      localStorage.setItem("clgv3", EncodeString(JSON.stringify(newLogin)));
      setIsLock(false); // Cập nhật state để đóng popup
    } catch (errorInfo) {
      Alertwarning(errorInfo.errorFields[0].errors);
      return;
    }
  };
  //#endregion

  return (
    <nav className="navbar navbar-expand-lg navbar-absolute fixed-top">
      <div className="container-fluid">
        <div className="navbar-wrapper">
          <a className="navbar-brand simple-text logo-normal" href="/home">
            <Img
              src="assets/img/LogoNetco.png"
              className="mar-left-100 margin-top-10s"
              width="190"
              height="50"
            />
          </a>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="navbar-toggler-icon icon-bar"></span>
          <span className="navbar-toggler-icon icon-bar"></span>
          <span className="navbar-toggler-icon icon-bar"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-center">
          <div className="input-group no-border">
            <i
              className="material-icons iconsearch"
              onClick={() => Link(Codesearch)}
            >
              search
            </i>
            <input
              type="text"
              className="form-control border-search"
              placeholder="Tìm kiếm mã vận đơn"
              value={Codesearch}
              {...bindCodesearch}
              onKeyPress={(e) => {
                onKeyUp(e);
              }}
              style={{ width: "350px" }}
            />
          </div>
        </div>
        <div
          className="collapse navbar-collapse justify-content-end"
          style={{ height: "35px" }}
        >
          {Customer?.CustomerID !== undefined ? MenuNoGroup : MenuHaveGroup}
        </div>

        <Modal
          title={
            <span className="red">
              BẠN CẦN ĐỔI MẬT KHẨU MỚI ĐỂ BẢO MẬT THÔNG TIN.
            </span>
          }
          open={isLock}
          width={600}
          zIndex={999999999}
          footer={false}
          maskClosable={false}
          closable={false}
          keyboard={false}
        >
          <Form
            form={form}
            onFinish={onFinish}
            name="password_change"
            layout="vertical"
          >
            <Form.Item
              name="newPassword"
              label="Mật khẩu mới"
              dependencies={["currentPassword"]}
              rules={[
                { required: true, message: "Vui lòng nhập mật khẩu mới" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("currentPassword") !== value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Mật khẩu mới không được trùng với mật khẩu hiện tại!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password onChange={handlePasswordChange} />
            </Form.Item>

            {form.getFieldValue("newPassword") && (
              <div style={{ marginBottom: 8, marginTop: -15 }}>
                <Progress
                  st
                  percent={(passwordStrength / 5) * 100}
                  showInfo={false}
                  strokeColor={strengthColors[passwordStrength]}
                />
                <div style={{ color: strengthColors[passwordStrength] }}>
                  {strengthLabels[passwordStrength]}
                </div>
              </div>
            )}

            <Form.Item
              name="confirmPassword"
              label="Xác nhận mật khẩu"
              dependencies={["newPassword"]}
              rules={[
                { required: true, message: "Vui lòng xác nhận mật khẩu" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    // Kiểm tra nếu trường xác nhận mật khẩu trống hoặc trùng với mật khẩu mới
                    // thì cho phép, nếu không thì báo lỗi
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Mật khẩu xác nhận không khớp");
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <div className="centered-row">
                <Button
                  color="danger"
                  variant="solid"
                  icon={<SaveOutlined />}
                  onClick={APIC_spCustomerResetPass_V2}
                >
                  Đổi mật khẩu
                </Button>
              </div>
            </Form.Item>
            <div style={{ marginTop: 12 }}>
              <Typography.Text
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <LockOutlined style={{ color: "#888", marginRight: 8 }} />
                Sử dụng ít nhất 6 ký tự
              </Typography.Text>
              <Typography.Text
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <LockOutlined style={{ color: "#888", marginRight: 8 }} />
                Sử dụng ít nhất 1 ký tự đặc biệt (vd: @!#...)
              </Typography.Text>
              <Typography.Text
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <LockOutlined style={{ color: "#888", marginRight: 8 }} />
                Sử dụng ít nhất 1 ký tự viết hoa (vd: A, H, C, ...)
              </Typography.Text>
            </div>

            <Form.Item name="formError" style={{ display: "none" }} />
            <Form.Item noStyle shouldUpdate>
              {() => {
                const error = form.getFieldError("formError");
                return error.length > 0 ? (
                  <div
                    style={{ color: "red", textAlign: "center", marginTop: 8 }}
                  >
                    {error[0]}
                  </div>
                ) : null;
              }}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </nav>
  );
};
